import { baseApi } from './baseApi';

export const rmaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRmas: builder.query({
      query: (params) => ({
        url: '/rma',
        params,
      }),
      providesTags: ['RmaTicket'],
    }),
    getRmaById: builder.query({
      query: (id) => `/rma/${id}`,
      providesTags: (result, error, id) => [{ type: 'RmaTicket', id }],
    }),
    createRma: builder.mutation({
      query: (data) => ({
        url: '/rma',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['RmaTicket', 'ProductImei', 'StockMovement'],
    }),
    updateRma: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/rma/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'RmaTicket', id },
        'RmaTicket',
        'ProductImei',
        'StockMovement'
      ],
    }),
  }),
});

export const {
  useGetRmasQuery,
  useGetRmaByIdQuery,
  useCreateRmaMutation,
  useUpdateRmaMutation,
} = rmaApi;
